<template>
  <!-- facebook кнопка -->
    <a
      v-if="isShowFacebookButton()"
      class="social-link"
      href="https://auth2.multiplex.ua/fblogin"
    >
      <RoundFacebookIcon />
    </a>
  <!-- facebook кнопка -->
</template>

<script>
  import Store from '../../../store'

  export default {
    name: 'FacebookBtn',
    methods: {
      isShowFacebookButton: function () {
        return Store.state.social_auth.facebook.isShowButton
      }
    }
  }
</script>


// WEBPACK FOOTER //
// FacebookBtn.vue?b565cae2